import React, { useEffect } from "react";
import ModalStructure from "../ModalStructure";
import { IoAlertCircle } from "react-icons/io5";
import { useLocation, useNavigate } from "react-router-dom";

const defaultProperties = {
  temperature: {
    title: "Temperatura",
    unit: "°C",
  },
  humidity: {
    title: "Humedad",
    unit: "%",
  },
  light: {
    title: "Luz",
    unit: "lm",
  },
  ph: {
    title: "Ph",
    unit: "",
  },
};

const WarningModal = ({ handleClose, message, data, userType, audio }) => {
  const location = useLocation();

  useEffect(() => {
    // Play the audio on loop when the modal opens
    if (audio) {
      audio.loop = true; // Enable looping
      audio.play().catch((err) => console.error("Audio play error:", err));
    }

    // Cleanup: Stop and reset the audio when the modal is closed
    return () => {
      if (audio) {
        audio.pause();
        audio.currentTime = 0; // Reset audio playback to the beginning
      }
    };
  }, [audio]);

  const navigate = useNavigate();

  return (
    <ModalStructure handleCloseModal={handleClose}>
      <div className="font poppins flex flex-col items-center justify-center gap-y-4 py-4 text-dark-green">
        <IoAlertCircle className="text-red-500 text-8xl" />
        <h1 className="text-center text-3xl font-bold font-poppins text-wrap">
          {message}:
        </h1>
        <h1 className="text-center text-5xl font-bold text-red-600 font-poppins">
          {data.value} {defaultProperties[data.property].unit}
        </h1>
        <div className="flex flex-col font-poppins p-4 bg-gray-200 rounded-xl max-w-[360px]">
          <h4 className="text-center text-xl font-bold m-1">Detalles:</h4>
          <p>
            <b>Propiedad: </b>
            {defaultProperties[data.property].title}
          </p>
          <p>
            <b>Fecha y hora: </b>
            {new Date(data.dateAndTime).toLocaleString()}
          </p>
          <p className="text-red-600">
            <b>
              Valor: {data.value} {defaultProperties[data.property].unit}
            </b>
          </p>
          <p>
            <b>Ambiente:</b> {data.ambient.name}
          </p>
          <p>
            <b>Observaciones:</b> {data.observations || "--"}
          </p>
          {data.wasLate == true && (
            <p className="text-orange-500">Registro tardío</p>
          )}
        </div>
        {userType == "EcosystemEditor" ? (
          <span className="font-poppins">Comunícate con el administrador</span>
        ) : (
          location.pathname != "/home/panel" && (
            <span
              onClick={() => {
                navigate("/home/panel");
                handleClose();
              }}
              className="hover:text-blue-500 hover:underline hover:cursor-pointer font-poppins"
            >
              ir al panel
            </span>
          )
        )}
      </div>
    </ModalStructure>
  );
};

export default WarningModal;
